import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Home, Search, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NotFound = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const slug = location.pathname.replace(/^\//, '');
    if (!slug) { setChecking(false); return; }

    axios.get(`${BACKEND_URL}/api/redirect-check/${slug}`)
      .then(resp => {
        if (resp.data?.target_url) {
          window.location.href = resp.data.target_url;
        } else {
          setChecking(false);
        }
      })
      .catch(() => setChecking(false));
  }, [location.pathname]);

  if (checking) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-red-500" />
      </div>
    );
  }

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        <div className="relative mb-8">
          <span className="text-[10rem] sm:text-[14rem] font-black text-gray-100 leading-none select-none block">404</span>
          <div className="absolute inset-0 flex items-center justify-center">
            <Search className="h-16 w-16 sm:h-20 sm:w-20 text-red-500 opacity-60" />
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3" data-testid="not-found-title">
          {t('errors.pageNotFound', 'Page Not Found')}
        </h1>
        <p className="text-gray-500 mb-8 text-sm sm:text-base max-w-md mx-auto" data-testid="not-found-description">
          {t('errors.pageNotFoundDesc', "Sorry, the page you're looking for doesn't exist or has been moved.")}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild className="bg-red-600 hover:bg-red-700 text-white">
            <Link to="/" data-testid="go-home-btn">
              <Home className="mr-2 h-4 w-4" />
              {t('errors.goHome', 'Go Home')}
            </Link>
          </Button>
          <Button asChild variant="outline" className="border-gray-300">
            <Link to="/shop" data-testid="browse-shop-btn">
              {t('errors.browseShop', 'Browse Shop')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
